import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Select, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

import { bookingJourneyType } from 'common/constants/booking';

const { Option } = Select;

const SelectBookingType = ({ onChange, value, disabledOption, ignoreOption, ...restProps }) => {
  const { t } = useTranslation();

  const bookingTypeOptions = [
    {
      label: t(`properties_booking_type_${bookingJourneyType.MANUAL.toLowerCase()}`),
      disabled: true,
      value: bookingJourneyType.MANUAL,
    },
    {
      label: t(`properties_booking_type_${bookingJourneyType.SEMI_AUTOMATIC.toLowerCase()}`),
      value: bookingJourneyType.SEMI_AUTOMATIC,
    },
    {
      label: t(`properties_booking_type_${bookingJourneyType.FULL_AUTOMATIC.toLowerCase()}`),
      value: bookingJourneyType.FULL_AUTOMATIC,
    },
    {
      label: t(`properties_booking_type_${bookingJourneyType.INSTANT_BOOK.toLowerCase()}`),
      value: bookingJourneyType.INSTANT_BOOK,
    },
    {
      label: t(`properties_booking_type_${bookingJourneyType.LEAD_GENERATION.toLowerCase()}`),
      value: bookingJourneyType.LEAD_GENERATION,
    },
  ];

  const selectValue = useMemo(
    () => (ignoreOption === value ? undefined : value),
    [ignoreOption, value],
  );

  return (
    <Select
      placeholder={t('cms.properties.create.basic_information.apartment_booking_type_placeholder')}
      onChange={onChange}
      value={selectValue}
      {...restProps}
    >
      <For each="bookingType" of={bookingTypeOptions}>
        <Option
          value={bookingType?.value}
          key={bookingType?.value}
          disabled={bookingType.disabled || bookingType.value === disabledOption}
        >
          {bookingType?.label}

          <If
            condition={
              bookingType.value === disabledOption &&
              bookingType.value === bookingJourneyType.FULL_AUTOMATIC
            }
          >
            <span>
              <Tooltip
                title={t('cms.properties.edit.detail.booking_type.tooltip_two')}
                placement="top"
              >
                <QuestionCircleOutlined style={{ marginLeft: 5, color: 'rgba(0, 0, 0, .45)' }} />
              </Tooltip>
            </span>
          </If>
        </Option>
      </For>
    </Select>
  );
};

SelectBookingType.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  disabledOption: PropTypes.string,
  ignoreOption: PropTypes.string,
};

export default SelectBookingType;
